import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_OCTOPUS_PETITION_SIGNER_RECEIPT_CONFIG = createFcmDetails(
	'octopus_petition_signer_receipt_config',
	{
		owner: 'Site Platform',
		context: 'comms stack',
		description:
			'Template experiment config for petition_signer_receipt message type. Leave the constraints empty [], to enable the experiment for all countries.',
		import: false,
		template: {
			name: '<experiment_name>',
			constraints: ['AR', 'AU', 'BR', 'CA', 'DE', 'ES', 'FR', 'GB', 'ID', 'IN', 'IT', 'JP', 'MX', 'TH', 'TR', 'US'],
		},
	},
);
